module.exports = __webpack_public_path__ + "static/media/Nguyen_Duc_Long.2e1f6a13.jpg";